import React, { FC } from 'react';
import { Send, Upload } from 'react-feather';
import LoadingSpinner from './LoadingSpinner';

interface ButtonProps {
  text?: string;
  position: keyof typeof ButtonPositions;
  icon?: keyof typeof Icons;
  loading?: number | boolean;
}

const ButtonPositions = {
  left: 'left-4',
  right: 'right-4',
};

const Icons = {
  send: <Send />,
  upload: <Upload />,
};

const FloatingButton: FC<ButtonProps> = ({ position, icon, loading }) => {
  return (
    <button
      className={`absolute top-1/2 -translate-x-1/2 -translate-y-1/2 hover:text-gray-600 dark:hover:text-gray-400 ${ButtonPositions[position]}`}
    >
      {loading ? <LoadingSpinner /> : Icons[icon]}
    </button>
  );
};

export default FloatingButton;
